import React from "react";
import { Route, Routes, BrowserRouter } from "react-router-dom";

import Index from "./Pages/Index";
import Menu from "./Pages/Menu";
import Motorista from "./Pages/Motorista";
import Visita from "./Pages/Visita";
import Mapa from "./Pages/Mapa";
import Historico from "./Pages/Historico";
import Ocorrencia from "./Pages/Ocorrencia";
import Roteamento from "./Pages/Roteamento";

const routeNames = {
  index: '/',
  menu: '/Menu',
  entregas: '/Motorista/:IDmotorista',
  visita: '/Visita/:IDmotorista/:IDvisita',
  mapa: '/Mapa',
  roteamento: '/Roteamento',
  historico: '/Historico/:IDmotorista',
  ocorrencia: '/Ocorrencias'
};

const Rotas = () => {
  return (
    <BrowserRouter>
      <Routes>
          <Route exact path={routeNames.index} element={<Index />} />
          <Route path={routeNames.menu} element={<Menu />} />
          <Route path={routeNames.mapa} element={<Mapa />} />
          <Route path={routeNames.roteamento} element={<Roteamento />} />
          <Route path={routeNames.entregas} element={<Motorista />} />
          <Route path={routeNames.visita} element={<Visita />} />
          <Route path={routeNames.historico} element={<Historico />} />
          <Route path={routeNames.ocorrencia} element={<Ocorrencia />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Rotas;
